import {AbstractControl, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";

export const required: ValidatorFn = Validators.required;
export const max_length_3: ValidatorFn = Validators.maxLength(3);
export const max_length_6: ValidatorFn = Validators.maxLength(6);
export const max_length_10: ValidatorFn = Validators.maxLength(10);
export const max_length_30: ValidatorFn = Validators.maxLength(30);
export const max_length_45: ValidatorFn = Validators.maxLength(45);
export const max_length_50: ValidatorFn = Validators.maxLength(50);
export const max_length_100: ValidatorFn = Validators.maxLength(100);
export const max_length_200: ValidatorFn = Validators.maxLength(200);
export const max_length_255: ValidatorFn = Validators.maxLength(255);
export const max_length_2000: ValidatorFn = Validators.maxLength(2000);
export const mediumTextValidator: ValidatorFn = Validators.maxLength(16777215); // Maximum length of mediumtext field in MySQL
export const requiredTrue: ValidatorFn = Validators.requiredTrue;


const alphabeticalRegex = /^[\p{L}\s-]+$/u;
export const alphabetical: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null =>
  alphabeticalRegex.test(control.value) ? null : {'alphabetical': true};

const numericalRegex = /^[0-9]*$/;
export const numerical: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null =>
  control.value === null || numericalRegex.test(control.value) ? null : {'numerical': true};

const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i
export const email: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null =>
  emailRegex.test(control.value) ? null : {'email': true};

export const emailAllowEmpty: ValidatorFn = (control: AbstractControl): { [key: string]: any } | null => {
  const value = control.value;

  if (value === null || value === undefined || value === '') {
    return null;
  }

  return emailRegex.test(value) ? null : { 'email': true };
};

const assignChipNumberRegex = /^(?:\s*\d+[\t ]+\d+(?:;\d+)*\s*(?:\r?\n)?)*$/;


export const assignChipNumbersValidator: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {
  if (!control.value) return null;

  if (assignChipNumberRegex.test(control.value)) {
    return null;
  }

  return {
    chipNumbers: true
  }
};


export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value;
    const errors: ValidationErrors = {};

    // Check length
    if (value.length < 8 || value.length > 30) {
      errors['length'] = {min: 8, max: 30};
    }

    // Check uppercase characters
    const uppercaseRegex = /[A-Z]/;
    if (!uppercaseRegex.test(value)) {
      errors['uppercase'] = true;
    }

    const lowercaseRegex = /[a-z]/;
    if (!lowercaseRegex.test(value)) {
      errors['lowercase'] = true;
    }

    // Check digits
    const digitRegex = /\d/;
    if (!digitRegex.test(value)) {
      errors['digit'] = true;
    }

    // Check special characters
    const specialRegex = /[!@#$%^&*(),.?":{}|<>]/;
    if (!specialRegex.test(value)) {
      errors['special'] = {chars: '!@#$%^&*(),.?":{}|<>'};
    }

    // // Check numerical sequences
    //   const numericalRegex = /\d{3}/;
    //   if (numericalRegex.test(value)) {
    //     errors['numericalSequence'] = true;
    //   }
    //
    // // Check alphabetical sequences
    //   const alphabeticalRegex = /[a-zA-Z]{3}/;
    //   if (alphabeticalRegex.test(value)) {
    //     errors['alphabeticalSequence'] = true;
    //   }

    // // Check QWERTY sequences
    // const qwertyRegex = /qwerty|asdfgh|zxcvbn/;
    // if (qwertyRegex.test(value)) {
    //   errors['qwertySequence'] = true;
    // }

    // Check whitespace characters
    const whitespaceRegex = /\s/;
    if (whitespaceRegex.test(value)) {
      errors['whitespace'] = true;
    }
    return Object.keys(errors).length > 0 ? errors : null;
  };
}
